/**
 * @description: 会员冲销报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="mr-hcx-report">
        <div class="member-hcx-list">
            <p class="p-hint">注：赠送账户及通用账户、房费账户消费金额均已扣除退款金额</p>
            <div class="row row-margin">
                <label class="list-label-4">消费时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="hcxTime">
                        <input type="text" class="form-control laydate-icon" placeholder="请选择消费时间" v-model="hcxStartTime" /> -
                        <input type="text" class="form-control laydate-icon" placeholder="请选择消费时间" v-model="hcxEndTime" />
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="hcxShop" data-placeholder="请选择会员卡所属门店"></select>
                </div>
                <label class="list-label-4">操作类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择操作类型" ref="hcx_optype">
                        <option value=" ">全部</option>
                        <option value="1">充值</option>
                        <option value="2">消费</option>
                    </select>
                </div>
                <label class="list-label-4">支付类型:</label>
                <div class="col-md-2 ct-col">
                    <input class="form-control input-readonly" placeholder="请选择支付类型" v-model="hcx_paytype_txt" ref="hcx_paytype_txt" readonly @click="hcxPaytypeFun">
                    <span class="selection-clear" @click="clearInput">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
            </div>
            <div class="row row-margin">
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="hcxQuery_conditions">
                        <option value="vip_card">会员卡号</option>
                        <option value="username">会员姓名</option>
                        <option value="mobile">会员手机号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="hcxSearch_info" :placeholder="hcxEmployeeinput">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitHcxTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getHcxExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="hcxList"></table>
            </div>
            <!-- 支付类型 -->
            <div class="ele-hide" ref="hcx_paytype_alert">
                <div class="multi-select">
                    <div class="clearfix">
                        <input type='checkbox' v-model='hcx_paytype_all' @click='hcxPaytypeCheckAll'>
                        <span>全选</span>
                    </div>
                    <ul class="clearfix">
                        <li v-for="item in hcx_paytype_arr" :key="item.id">
                            <input type="checkbox" v-model='hcx_paytype_item' :value="item.id">
                            <span>{{item.name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="hcxExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='hcxExport_allcheck' @click='hcxExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="username">
                            <label>会员姓名</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="vip_card">
                            <label>会员卡号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="level_name">
                            <label>会员等级</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="mobile">
                            <label>会员手机号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="create_time">
                            <label>操作时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="type_name">
                            <label>操作类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="pay_platform">
                            <label>支付类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="vip_present_account">
                            <label>赠送账户进出金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="vip_account">
                            <label>通用账户进出金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="vip_room_account">
                            <label>房费账户进出金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="amount">
                            <label>实际金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="before_account">
                            <label>操作前通用金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="before_present_account">
                            <label>操作前赠送金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="before_room_account">
                            <label>操作前房费金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="after_account">
                            <label>操作后通用金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="after_present_account">
                            <label>操作后赠送金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="after_room_account">
                            <label>操作后房费金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="relation_id">
                            <label>单号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="book_admin_name">
                            <label>预定员工</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="introducer_name">
                            <label>介绍人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hcxExport_checkModel' value="commission_admin_name">
                            <label>提成人</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='hcxExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='hcxExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 预约导出弹窗 -->
            <div class="book-export-pop ele-hide" ref="book_export_pop">
                <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
                <div class="pop-row center">
                    <el-button type="primary" @click="doBookExport">预约导出</el-button>
                    <el-button @click="cancelExport">取消</el-button>
                </div>
                <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
                <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                    <div class="time">{{book_export_log_list[0].create_time}}</div>
                    <div class="right">
                        <span class="status">{{book_export_log_list[0].status_name}}</span>
                        <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                hcxStartTime: "",
                hcxEndTime: "",
                hcx_paytype_txt: "",
                hcx_paytype_all: false,
                c_hcx_paytype_all: false,
                hcx_paytype_item: [],
                hcx_paytype_arr: [],
                hcxSearch_field: "vip_card",
                hcxEmployeeinput: '请输入会员卡号',
                hcxSearch_info: "",
                hcxExport_allcheck: false,
                c_hcxExport_allcheck: false,
                hcxExport_checkModel: [],
                hcxExport_checkData: ['shop_name', 'username', 'vip_card', 'level_name', 'mobile', 'create_time', 'type_name', 'pay_platform', 'vip_present_account', 'vip_account', 'vip_room_account', 'amount', 'before_account', 'before_present_account', 'before_room_account', 'after_account', 'after_present_account', 'after_room_account', 'relation_id', 'book_admin_name', 'introducer_name', 'commission_admin_name'],
                hcxExport_type: 1,
                list_page: 1,
                book_export_log_list: [],
            }
        },
        watch: {
            hcx_paytype_txt: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.hcx_paytype_txt).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.hcx_paytype_txt).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            hcx_paytype_item: {
                handler: function(val, oldVal) {
                    if(this.hcx_paytype_item.length >= this.hcx_paytype_arr.length) {
                        this.hcx_paytype_all = true;
                        this.c_hcx_paytype_all = true;
                    } else {
                        this.hcx_paytype_all = false;
                        this.c_hcx_paytype_all = false;
                    }
                },
                deep: true
            },
            hcxSearch_info: {
                handler: function(val, oldVal) {
                    if(val != '') {
                        this.hcxStartTime = '';
                        this.hcxEndTime = '';
                    }
                },
                deep: true
            },
            hcxExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.hcxExport_checkModel.length >= this.hcxExport_checkData.length) {
                        this.hcxExport_allcheck = true;
                        this.c_hcxExport_allcheck = true;
                    } else {
                        this.hcxExport_allcheck = false;
                        this.c_hcxExport_allcheck = false;
                    }
                },
                deep: true
            },
            '$route': {
                handler: function(val, oldVal) {
                    if(val.params.vip_card) {
                        this.hcxSearch_field = 'vip_card'
                        this.hcxSearch_info = val.params.vip_card
                        $(this.$refs.hcxShop).val('').trigger('change');
                        this.hcxStartTime = ''
                        this.hcxEndTime = ''
                        this.innitHcxTable();
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.hcxStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.hcxEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            $(_this.$refs.hcx_optype).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            });
            // 下拉选项
            $(_this.$refs.hcxQuery_conditions).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
            }).change(function() {
                _this.hcxSearch_field = $(this).val();
                if(_this.hcxSearch_field == 'vip_card') {
                    _this.hcxEmployeeinput = '请输入会员卡号';
                } else if(_this.hcxSearch_field == 'username') {
                    _this.hcxEmployeeinput = '请输入会员姓名';
                } else if(_this.hcxSearch_field == 'mobile') {
                    _this.hcxEmployeeinput = '请输入会员手机号';
                }
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.hcxStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.hcxEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.hcxStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.hcxEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.hcxTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                }, function(start, end, label) {
                    _this.hcxSearch_info = '';
                    _this.hcxStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.hcxEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.hcxShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.getPaytype(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            // 第一次打开
                            if(_this.$route.params.vip_card) {
                                console.log(_this.$route.params)
                                _this.hcxSearch_field = 'vip_card'
                                _this.hcxSearch_info = _this.$route.params.vip_card
                                $(_this.$refs.hcxShop).val('').trigger('change');
                                _this.hcxStartTime = ''
                                _this.hcxEndTime = ''
                                // 获取支付类型
                                _this.getPaytype(data.response.result[0].id);
                            } else {
                                $(_this.$refs.hcxShop).val(data.response.result[1].id).trigger('change');
                                _this.setShopDefaultTime(data.response.result[1].id)
                                // 获取支付类型
                                _this.getPaytype(data.response.result[1].id);
                            }
                            _this.innitHcxTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取支付类型
            getPaytype: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Order/getAllPayPlatform",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [];
                            let value = data.response.data;
                            for(var key in value) {
                                arr.push({id: key, name: value[key]});
                            }
                            _this.hcx_paytype_arr = arr;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            // 点击选择支付类型
            hcxPaytypeFun: function(e) {
                let _this = this;
                let c_hcx_paytype_item = _this.hcx_paytype_item;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], //按钮
                    title: ['支付类型', true],
                    area: ['700px', ''], //宽高
                    content: $(_this.$refs.hcx_paytype_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.hcx_paytype_txt != "") {
                            _this.hcx_paytype_item = c_hcx_paytype_item;
                            return;
                        }
                        _this.hcx_paytype_item = [];
                    }
                }, function() {
                    let texts = [];
                    _this.hcx_paytype_arr.forEach(function(item) {
                        _this.hcx_paytype_item.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.hcx_paytype_txt = texts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.hcx_paytype_txt != "") {
                        _this.hcx_paytype_item = c_hcx_paytype_item;
                        return;
                    }
                    _this.hcx_paytype_item = [];
                });
            },
            // 支付类型全选
            hcxPaytypeCheckAll: function() {
                let _this = this;
                _this.hcx_paytype_all = _this.c_hcx_paytype_all;
                if(!_this.hcx_paytype_all) { // 实现全选
                    _this.hcx_paytype_item = [];
                    _this.hcx_paytype_arr.forEach(function(item) {
                        _this.hcx_paytype_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.hcx_paytype_item = [];
                }
            },
            // 清空多选
            clearInput: function() {
                this.hcx_paytype_txt = "";
                this.hcx_paytype_item = [];
            },
            // 初始化会员冲销报表
            innitHcxTable: function() {
                let _this = this;
                $(_this.$refs.hcxList).bootstrapTable('destroy');
                $(_this.$refs.hcxList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getHcxList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        valign: 'middle',
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        valign: 'middle',
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "username",
                        title: "会员姓名",
                        valign: 'middle'
                    }, {
                        field: "vip_card",
                        title: "会员卡号",
                        width: "110",
                        valign: 'middle'
                    }, {
                        field: "level_name",
                        title: "会员等级",
                        valign: 'middle'
                    }, {
                        field: "mobile",
                        title: "会员手机号",
                        width: "110",
                        valign: 'middle'
                    }, {
                        field: "create_time",
                        title: "操作时间",
                        width: "110",
                        valign: 'middle'
                    }, {
                        field: "type_name",
                        title: "操作类型",
                        valign: 'middle'
                    }, {
                        field: "pay_platform",
                        title: "支付类型",
                        valign: 'middle'
                    }, {
                        field: "vip_present_account",
                        title: "赠送账户<br />进出金额",
                        valign: 'middle'
                    }, {
                        field: "vip_account",
                        title: "通用账户<br />进出金额",
                        valign: 'middle'
                    }, {
                        field: "vip_room_account",
                        title: "房费账户<br />进出金额",
                        valign: 'middle'
                    }, {
                        field: "amount",
                        title: "实际金额",
                        valign: 'middle'
                    }, {
                        field: "before_account",
                        title: "操作前<br />通用金额",
                        valign: 'middle'
                    }, {
                        field: "before_present_account",
                        title: "操作前<br />赠送金额",
                        valign: 'middle'
                    }, {
                        field: "before_room_account",
                        title: "操作前<br />房费金额",
                        valign: 'middle'
                    }, {
                        field: "after_account",
                        title: "操作后<br />通用金额",
                        valign: 'middle'
                    }, {
                        field: "after_present_account",
                        title: "操作后<br />赠送金额",
                        valign: 'middle'
                    }, {
                        field: "after_room_account",
                        title: "操作后<br />房费金额",
                        valign: 'middle'
                    }, {
                        field: "relation_id",
                        title: "单号",
                        width: "110",
                        valign: 'middle'
                    }, {
                        field: "book_admin_name",
                        title: "预定员工",
                        valign: 'middle'
                    }, {
                        field: "introducer_name",
                        title: "介绍人",
                        valign: 'middle'
                    }, {
                        field: "commission_admin_name",
                        title: "提成人",
                        valign: 'middle'
                    }]
                });
            },
            getHcxList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                _this.list_page = pageNumber;
                let vip_card = '',
                    username = '',
                    mobile = '';
                if(_this.hcxSearch_field == 'vip_card') {
                    vip_card = _this.hcxSearch_info;
                } else if(_this.hcxSearch_field == 'username') {
                    username = _this.hcxSearch_info;
                } else if(_this.hcxSearch_field == 'mobile') {
                    mobile = _this.hcxSearch_info;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.hcxStartTime,
                            "end_time": _this.hcxEndTime,
                            "shop_id": $(_this.$refs.hcxShop).val(),
                            "type": $.trim($(_this.$refs.hcx_optype).val()),
                            "pay_platform": _this.hcx_paytype_item,
                            "vip_card": vip_card,
                            "username": username,
                            "mobile": mobile
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getVipAccountLog",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.data.total,
                                rows: data.response.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getHcxExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/vipAccountLogExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.hcxExport_checkModel = data.response.result.export_fields;
                                _this.hcxExport_type = data.response.result.export_type;
                            } else {
                                _this.hcxExport_checkModel = _this.hcxExport_checkData;
                                _this.hcxExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.hcxExport_alert)
                }, function() {
                    _this.checkExport();
                });
            },
            // 导出字段全选
            hcxExportCheckedAll: function() {
                let _this = this;
                _this.hcxExport_allcheck = _this.c_hcxExport_allcheck;
                if(!_this.hcxExport_allcheck) { // 实现全选
                    _this.hcxExport_checkModel = [];
                    _this.hcxExport_checkData.forEach(function(item) {
                        _this.hcxExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.hcxExport_checkModel = [];
                }
            },

            // 检查导出状态
            checkExport() {
                let _this = this;
                let vip_card = '',
                    username = '',
                    mobile = '';
                if (_this.hcxSearch_field == 'vip_card') {
                    vip_card = _this.hcxSearch_info;
                } else if (_this.hcxSearch_field == 'username') {
                    username = _this.hcxSearch_info;
                } else if (_this.hcxSearch_field == 'mobile') {
                    mobile = _this.hcxSearch_info;
                }
                Vue.axios.post('exportBook/exportCheck', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'VipAccountLog',
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.hcxStartTime,
                            "end_time": _this.hcxEndTime,
                            "shop_id": $(_this.$refs.hcxShop).val(),
                            "type": $.trim($(_this.$refs.hcx_optype).val()),
                            "pay_platform": _this.hcx_paytype_item,
                            "vip_card": vip_card,
                            "username": username,
                            "mobile": mobile,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.exportHcxList();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 预约导出
            doBookExport() {
                let _this = this;

                let export_fields = JSON.stringify(_this.hcxExport_checkModel);
                let vip_card = '',
                    username = '',
                    mobile = '';
                if (_this.hcxSearch_field == 'vip_card') {
                    vip_card = _this.hcxSearch_info;
                } else if (_this.hcxSearch_field == 'username') {
                    username = _this.hcxSearch_info;
                } else if (_this.hcxSearch_field == 'mobile') {
                    mobile = _this.hcxSearch_info;
                };

                Vue.axios.post('exportBook/addExportBook', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'VipAccountLog',
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.hcxStartTime,
                            "end_time": _this.hcxEndTime,
                            "shop_id": $(_this.$refs.hcxShop).val(),
                            "type": $.trim($(_this.$refs.hcx_optype).val()),
                            "pay_platform": _this.hcx_paytype_item,
                            "vip_card": vip_card,
                            "username": username,
                            "mobile": mobile,
                            "export_fields": export_fields,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.book_export_log_list = res.data.response.result.log_list
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },

            // 确定“导出”
            exportHcxList: function() {
                let _this = this;

                let export_fields = JSON.stringify(_this.hcxExport_checkModel);
                let vip_card = '',
                    username = '',
                    mobile = '';
                if(_this.hcxSearch_field == 'vip_card') {
                    vip_card = _this.hcxSearch_info;
                } else if(_this.hcxSearch_field == 'username') {
                    username = _this.hcxSearch_info;
                } else if(_this.hcxSearch_field == 'mobile') {
                    mobile = _this.hcxSearch_info;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/vipAccountLogExport?" +
                    "&start_time=" + _this.hcxStartTime +
                    "&end_time=" + _this.hcxEndTime +
                    "&shop_id=" + $(_this.$refs.hcxShop).val() +
                    "&type=" + $.trim($(_this.$refs.hcx_optype).val()) +
                    "&pay_platform=" + _this.hcx_paytype_item +
                    "&vip_card=" + vip_card +
                    "&username=" + username +
                    "&mobile=" + mobile +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.hcxExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .member-hcx-list {
        .table-responsive {
            .fixed-table-body {
                overflow-x: scroll;
                table {
                    width: 1700px;
                    max-width: 2000px;
                    // table-layout: fixed;
                    word-break: break-all;
                }
            }
            .fixed-table-body::-webkit-scrollbar {
                position: absolute;
                top: 0;
                left: 0;
                height: 30px;
            }
        }
    }
    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>